import { useEffect } from 'react';
import { message } from 'antd';
export const AntdConfig = () => {
    useEffect(() => {
        message.config({
            top: 88,
            rtl: false,
        });
    }, []);
    return null;
};
